import {Component, OnInit} from '@angular/core';
import {ClubService, FunctionariesSortedByGroup} from '@core/services/club.service';
import { TeamService } from '@core/services/team.service';
import { AppTeam } from '@shared/models/team';
import { StateService } from '@core/services/state.service';

@Component({
  selector: 'team-info-functionaries',
  templateUrl: './team-info-functionaries.component.html',
  styleUrls: ['./team-info-functionaries.component.scss'],
})

export class TeamInfoFunctionariesComponent implements OnInit {

  sortedFunctionaries: FunctionariesSortedByGroup[] = [];
  private team: AppTeam;

  constructor( private appStateService: StateService,
               private teamService: TeamService,
               private clubService: ClubService ) {}

  ngOnInit() {
    this.team = this.teamService.getCurrentTeam();
    this.loadFunctionaries();
  }

  private loadFunctionaries() {
    if (!this.team?.clubid) {
      return;
    }
    this.clubService.fetchClubOfficialsAndOrderByGroup(this.team.clubid).then(sortedFunctionaries => {
      this.sortedFunctionaries = sortedFunctionaries;
    });
  }

}
